module.exports = __webpack_public_path__ + "media/question2_au.6f83cda9.mp3";